export default {
  current: null,
  data: [],
  loading: true,
  error: false,
  populationsByLocation: {
    data: [],
    loading: true
  },
  filters: {
    family_id: [],
    framework_id: [],
    flyway_region_id: [],
    ramsar_region_id: [],
    red_list_id: [],
    publication_id: 0,
  },
  publications: [],
  search: ''
}
